// react component
import React, { useState } from 'react';
import {
  Grid,
  Box,
  FormControl,
  TextField,
  Button,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
  IconButton,
  Table,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useAuth } from 'oidc-react';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

const ListRekomendasi = ({
  input,
  loading,
  setInput,
  readOnly,
  setSnackbar,
}) => {
  const [rekomendasiInput, setRekomendasiInput] = useState('');
  const { userData } = useAuth();

  const handleAddRekomendasi = (e) => {
    if (readOnly) return;

    if (rekomendasiInput === '') {
      setSnackbar({
        isOpen: true,
        type: 'warning',
        message: 'Rekomendasi tidak boleh kosong',
      });
      return;
    }

    let id = input.listRekomendasi.length + 1;

    for (let i = 0; i < input.listRekomendasi.length; i++) {
      if (input.listRekomendasi[i].id === id) {
        id++;
      }
    }

    setInput((prev) => ({
      ...prev,
      listRekomendasi: [
        ...prev.listRekomendasi,
        {
          id: null,
          rekomendasi: rekomendasiInput,
          addBy: userData?.profile?.email,
          key: id,
        },
      ],
    }));

    setRekomendasiInput('');
  };

  const handleRemoveRekomendasi = (row) => {
    if (readOnly) return;
    setInput((prev) => ({
      ...prev,
      listRekomendasi: prev.listRekomendasi.filter((dt) => {
        if (row.id) {
          return dt.id !== row.id;
        }

        return dt.key !== row.key;
      }),
    }));
  };

  const handleEditRekomendasi = (row, value) => {
    if (readOnly) return;
    setInput((prev) => ({
      ...prev,
      listRekomendasi: prev.listRekomendasi.map((dt) => {
        if (row.id) {
          if (dt.id === row.id) {
            dt.rekomendasi = value;
          }
        }

        if (dt.key === row.key) {
          dt.rekomendasi = value;
        }

        return dt;
      }),
    }));
  };

  const ActionRekomendasi = ({
    dt,
    handleRemoveRekomendasi,
    handleEditRekomendasi,
    readOnly,
  }) => {
    const [editMode, setEditMode] = useState(false);
    const [editedValue, setEditedValue] = useState(dt.rekomendasi);

    const handleEditClick = () => {
      setEditMode(true);
    };

    const handleSaveClick = () => {
      handleEditRekomendasi(dt, editedValue);
      setEditMode(false);
    };

    const handleCancelClick = () => {
      setEditedValue(dt.rekomendasi);
      setEditMode(false);
    };

    return (
      <>
        {editMode ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <TextField
                value={editedValue}
                onChange={(e) => setEditedValue(e.target.value)}
                disabled={readOnly}
                style={{ flex: 1 }}
              />
              <IconButton
                color="primary"
                onClick={handleSaveClick}
                disabled={readOnly}
              >
                <SaveIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={handleCancelClick}
                disabled={readOnly}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </>
        ) : (
          <>
            <TableCell style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: 'auto' }}>{dt.rekomendasi}</span>
              <IconButton
                color="primary"
                onClick={handleEditClick}
                disabled={readOnly}
              >
                <EditIcon />
              </IconButton>
              <IconButton
                color="primary"
                onClick={() => handleRemoveRekomendasi(dt)}
                disabled={readOnly}
              >
                <DeleteIcon />
              </IconButton>
            </TableCell>
          </>
        )}
      </>
    );
  };

  return (
    <Grid item xl={12} lg={12} sm={12} xs={12}>
      <h3 style={{ textAlign: 'left' }}>List Rekomendasi</h3>
      <Grid container rowGap={1} columnGap={1}>
        <Grid item xs={10}>
          <FormControl fullWidth>
            <TextField
              label="Ketik rekomenasi"
              onChange={(e) => {
                setRekomendasiInput(e.target.value);
              }}
              value={rekomendasiInput}
              disabled={readOnly}
            />
          </FormControl>
        </Grid>
        <Grid item xs={1}>
          <Button
            variant="contained"
            sx={{ fontSize: '1.5rem', height: '100%' }}
            onClick={handleAddRekomendasi}
            disabled={readOnly}
          >
            +
          </Button>
        </Grid>
      </Grid>
      <Table>
        <TableHead>
          <TableCell>Rekomendasi</TableCell>
          <TableCell></TableCell>
        </TableHead>
        <TableBody>
          {input.listRekomendasi.length > 0 &&
            input.listRekomendasi?.map((dt, idx) => (
              <TableRow key={idx}>
                <ActionRekomendasi
                  dt={dt}
                  handleRemoveRekomendasi={handleRemoveRekomendasi}
                  handleEditRekomendasi={handleEditRekomendasi}
                  readOnly={readOnly}
                />
              </TableRow>
            ))}
          {input.listRekomendasi.length === 0 && (
            <TableRow>
              <TableCell colSpan={2} style={{ textAlign: 'center' }}>
                Belum ada rekomendasi
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default ListRekomendasi;
